import { render, staticRenderFns } from "./cartHeptagon.vue?vue&type=template&id=81ac4a46&"
import script from "./cartHeptagon.vue?vue&type=script&lang=js&"
export * from "./cartHeptagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports